import { WeighingType } from "../../../../domain/model/weighing-type";
import { DataStoreId } from "../../data-store-id.type";
import { StoreUpdateInfo } from "../../../store-update-info";
import { Uuid } from "../../../../domain/model/uuid/uuid.type";

export class StoreAnimalWeighing implements DataStoreId {
  readonly id: string;
  readonly batchWeighingId: string;
  readonly sectionId: string;
  readonly trialId: string;
  readonly penId: string;
  readonly groupId: string;
  readonly feedId: string;
  readonly updateInfo: StoreUpdateInfo;
  readonly type: WeighingType;
  readonly inputNumber: number;
  readonly inputWeight: number;

  constructor(
    id: Uuid,
    batchWeighingId: Uuid,
    sectionId: Uuid,
    trialId: Uuid,
    penid: Uuid,
    groupId: Uuid,
    feedId: Uuid,
    type: WeighingType,
    updateInfo: StoreUpdateInfo,
    inputNumber: number,
    inputWeight: number
  ) {
    this.id = id.asString();
    this.batchWeighingId = batchWeighingId.asString();
    this.sectionId = sectionId.asString();
    this.trialId = trialId.asString();
    this.penId = penid.asString();
    this.groupId = groupId.asString();
    this.feedId = feedId.asString();
    this.type = type;
    this.updateInfo = updateInfo;
    this.inputNumber = inputNumber;
    this.inputWeight = inputWeight;
  }
}
